import request from '../../../requestInstance';
import { CommonResult } from '../../CommonType';
import type {
  FeedbackAttachmentItem,
  FeedbackCreateRequest,
  FeedbackEditRequest,
  FeedbackItem,
  FeedbackTargetRoleItem,
  FeedbackUpdateRequest,
  ReleaseNoteItem,
  ReleaseNoteSaveRequest,
} from './types';

export async function listReleaseNotes(params?: { includeDraft?: boolean }) {
  return request<CommonResult<ReleaseNoteItem[]>>('/api/system-feedback/releases', {
    method: 'GET',
    params,
  });
}

export async function listUnreadReleaseNotes(options?: { [key: string]: any }) {
  return request<CommonResult<ReleaseNoteItem[]>>('/api/system-feedback/releases/unread', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function listFeedbackTargetRoles() {
  return request<CommonResult<FeedbackTargetRoleItem[]>>('/api/system-feedback/roles', {
    method: 'GET',
  });
}

export async function createReleaseNote(data: ReleaseNoteSaveRequest) {
  return request<CommonResult<ReleaseNoteItem>>('/api/system-feedback/releases/create', {
    method: 'POST',
    data,
  });
}

export async function updateReleaseNote(data: ReleaseNoteSaveRequest) {
  return request<CommonResult<ReleaseNoteItem>>('/api/system-feedback/releases/update', {
    method: 'PUT',
    data,
  });
}

export async function markReleaseNotesAsRead(releaseIds: number[]) {
  return request<CommonResult<void>>('/api/system-feedback/releases/read', {
    method: 'POST',
    data: { releaseIds },
  });
}

export async function listFeedbacks() {
  return request<CommonResult<FeedbackItem[]>>('/api/system-feedback/feedbacks', {
    method: 'GET',
  });
}

export async function createFeedback(data: FeedbackCreateRequest) {
  return request<CommonResult<FeedbackItem>>('/api/system-feedback/feedbacks/create', {
    method: 'POST',
    data,
  });
}

export async function updateFeedback(data: FeedbackUpdateRequest) {
  return request<CommonResult<FeedbackItem>>('/api/system-feedback/feedbacks/update', {
    method: 'PUT',
    data,
  });
}

export async function editFeedback(data: FeedbackEditRequest) {
  return request<CommonResult<FeedbackItem>>('/api/system-feedback/feedbacks/edit', {
    method: 'PUT',
    data,
  });
}

export async function deleteFeedback(feedbackId: number) {
  return request<CommonResult<void>>(`/api/system-feedback/feedbacks/${feedbackId}`, {
    method: 'DELETE',
  });
}

export async function uploadFeedbackAttachment(feedbackId: number, file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return request<CommonResult<FeedbackAttachmentItem>>(
    `/api/system-feedback/feedbacks/${feedbackId}/attachments/upload`,
    {
      method: 'POST',
      data: formData,
    },
  );
}

export async function listFeedbackAttachments(feedbackId: number) {
  return request<CommonResult<FeedbackAttachmentItem[]>>(
    `/api/system-feedback/feedbacks/${feedbackId}/attachments`,
    {
      method: 'GET',
    },
  );
}

export async function deleteFeedbackAttachment(feedbackId: number, attachmentId: number) {
  return request<CommonResult<void>>(
    `/api/system-feedback/feedbacks/${feedbackId}/attachments/${attachmentId}`,
    {
      method: 'DELETE',
    },
  );
}
